import React from 'react';
import { AnnouncementBar } from '@ezetech/swag-space-x';
export const ResellerContractPendingSignWidgetComponent = ({
  isResellerAdmin,
  isWidgetShown,
  acceptResellerContract
}) => {
  const buttonText = isResellerAdmin ? 'View Contract' : undefined;
  const textRight = isResellerAdmin ? 'Please sign to make active' : undefined;
  const textLeft = isResellerAdmin ? 'Your site is not active' : 'This store is not active';
  const handleButtonClick = () => {
    if (isResellerAdmin) {
      acceptResellerContract();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, isWidgetShown && /*#__PURE__*/React.createElement(AnnouncementBar, {
    textLeft: textLeft,
    textRight: textRight,
    buttonLabel: buttonText,
    onClick: handleButtonClick
  }));
};